export default (theme) => ({
  approvalDraggableElem: {
    outline: `2px solid ${theme.palette.primary.main}`,
  },
  approvalDraggableElemDisabledDrop: {
    outlineColor: theme.palette.error.main,
  },
});
